import React, { Component } from 'react';
import styled from 'styled-components';

const TabBody = styled.div`
    margin: ${props => props.margin || '30px 0'};
`;

class Tab extends Component {
    render() {
        const { children, margin } = this.props;
        if (!children) {
            return null;
        }
        return (
            <TabBody margin={margin} className={'ym-hide-content'}>
                {children}
            </TabBody>
        );
    }
}

export default Tab;
